import { ShareDialogComponent } from "@/components/share-dialog/share-dialog.component";
import { ActionDoneType } from "@/enums/ActionDoneType.enum";
import { UserHelper } from "@/helpers/user.helper";
import { AppConfigService } from "@/services/app-config.service";
import { NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import {
  RealProperty,
  Sharing,
  SharingService,
  UserSession,
} from "@eemo/api-client";
import { Subscription } from "rxjs";
import { ShareTableComponent } from "../../../components/share-table/share-table.component";

@Component({
  selector: "app-property-shares",
  templateUrl: "./property-shares.component.html",
  styleUrls: ["./property-shares.component.scss"],
  standalone: true,
  imports: [NgIf, ShareTableComponent, MatButtonModule, MatIconModule],
})
export class PropertySharesComponent implements OnInit, OnDestroy {
  currentUser: UserSession;
  prop: RealProperty;
  propShares: Sharing[] = [];
  sub = new Subscription();

  canAddShare = false;
  canViewIncreaseTooltip = false;
  canUpdateProperty = false;

  constructor(
    private appConfigService: AppConfigService,
    private sharingService: SharingService,
    private dialog: MatDialog,
    private userHelper: UserHelper
  ) {}

  ngOnInit() {
    this.prop = this.appConfigService.selectedProp;
    this.canUpdateProperty = this.userHelper.canUpdateProperty(this.prop);
    this.canAddShare = this.userHelper.canAddPropertyShare(this.prop);
    this.canViewIncreaseTooltip =
      this.canAddShare &&
      (this.userHelper.isAdmin() || this.userHelper.isRealEstate());
    this.loadData();
    this.sub = this.appConfigService.actionDone.subscribe((type) => {
      if (type === ActionDoneType.SHARE) {
        this.loadData();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  loadData() {
    // TODO manage pagination
    this.sharingService
      .getRealPropertySharingList(this.prop.uid)
      .subscribe((shareList) => {
        const list: Sharing[] = [];
        shareList.forEach((share) => list.push(share));
        this.propShares = list;
      });
  }

  addShare() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ShareDialogComponent, {
        // width: '20rem'
        data: { props: [this.prop] },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.appConfigService.triggerActionDone(ActionDoneType.SHARE);
        }
      });
    }
  }
}
